import React from "react"
import { Container, LoadingBg, LoadingItem } from "./loading-spinner.styles"

const LoadingSpinner = () => {
  return (
    <Container>
      <LoadingBg>
        <LoadingItem></LoadingItem>
      </LoadingBg>
    </Container>
  )
}

export default LoadingSpinner
